import script from "./messageBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./messageBubble.vue?vue&type=script&setup=true&lang=js"

import "./messageBubble.vue?vue&type=style&index=0&id=2b71022b&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b71022b"]])

export default __exports__